/* Pata Mama — independent, dependency-free Shopify storefront interactions. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const parse = (element, fallback = {}) => { try { return JSON.parse(element?.textContent || ''); } catch { return fallback; } };
  const config = parse($('#PataConfig'));
  const root = (config.root || '/').replace(/\/?$/, '/');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cleanText = value => new DOMParser().parseFromString(String(value || ''), 'text/html').body.textContent;
  const announce = text => { const live = $('[data-announcement]'); if (live) live.textContent = text; };
  const openers = new WeakMap();
  const heroes = new Map();
  let cartBusy = false;
  let searchAbort;
  let searchTimer;
  function openDialog(dialog, opener) {
    if (!dialog) return;
    openers.set(dialog, opener || document.activeElement);
    if (!dialog.open) dialog.showModal();
    const input = $('input:not([type=hidden])', dialog);
    if (input) input.focus();
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.close();
    const opener = openers.get(dialog);
    if (opener?.isConnected) opener.focus();
  }
  function bindDialogs(scope) {
    $$('dialog', scope).forEach(dialog => {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = 'true';
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) closeDialog(dialog);
      });
      dialog.addEventListener('close', () => {
        const opener = openers.get(dialog);
        if (opener?.isConnected) opener.focus();
      });
    });
  }
  async function jsonRequest(url, options = {}) {
    const response = await fetch(url, {...options, headers: {Accept:'application/json', ...(options.headers || {})}});
    let data;
    try { data = await response.json(); } catch { throw new Error('Bağlantı kurulamadı. Lütfen tekrar deneyin.'); }
    if (!response.ok) throw new Error(data.description || data.message || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.');
    return data;
  }
  async function updateCart(sections, count) {
    let html = sections?.['cart-drawer'];
    if (!html) {
      const result = await jsonRequest(`${root}?sections=cart-drawer`);
      html = result['cart-drawer'];
    }
    if (!html) throw new Error('Ürün sepete işlendi; güncel sepeti sepet sayfasından görüntüleyin.');
    const next = new DOMParser().parseFromString(html, 'text/html');
    const content = $('[data-cart-contents]', next);
    const current = $('#CartDrawer [data-cart-contents]');
    if (!content || !current) throw new Error('Sepet güncellenemedi. Sepet sayfasını açın.');
    current.replaceWith(content);
    if (count === undefined) count = (await jsonRequest(`${root}cart.js`)).item_count;
    $$('[data-cart-count]').forEach(el => { el.textContent = String(count); });
    document.dispatchEvent(new CustomEvent('pata:cart-updated', {detail:{itemCount:count}}));
  }
  async function addToCart(form) {
    const submit = $('[type=submit]', form);
    if (form.dataset.busy === 'true' || submit?.disabled) return;
    if (cartBusy) { announce('Sepet güncelleniyor. Lütfen kısa bir süre bekleyin.'); return; }
    cartBusy = true;
    document.dispatchEvent(new CustomEvent('pata:cart-busy',{detail:{busy:true}}));
    const error = $('[data-form-error]', form);
    form.dataset.busy = 'true';
    if (error) error.textContent = '';
    if (submit) { submit.disabled = true; submit.setAttribute('aria-busy','true'); }
    try {
      const payload = new FormData(form);
      payload.append('sections', 'cart-drawer');
      payload.append('sections_url', location.pathname);
      const data = await jsonRequest(config.add || `${root}cart/add.js`, {method:'POST', body:payload});
      announce('Ürün sepetinize eklendi.');
      if (document.body.dataset.cartDrawer !== 'true') { location.assign(config.cart || `${root}cart`); return; }
      await updateCart(data.sections);
      openDialog($('#CartDrawer'), submit);
    } catch (e) {
      if (error) error.textContent = e.message;
      announce(e.message);
    } finally {
      delete form.dataset.busy;
      cartBusy = false;
      if (submit) { submit.disabled = false; submit.removeAttribute('aria-busy'); }
      document.dispatchEvent(new CustomEvent('pata:cart-busy',{detail:{busy:false}}));
      const section = form.closest('[data-product-section]');
      if (section) updateVariant(section, false);
    }
  }
  async function changeCart(button) {
    if (cartBusy) return;
    cartBusy = true;
    const drawer = $('#CartDrawer');
    const oldKey = button.dataset.key;
    const quantity = Number(button.dataset.quantity);
    const error = $('[data-cart-error]', drawer);
    if (error) error.textContent = '';
    drawer?.classList.add('is-busy');
    try {
      const data = await jsonRequest(config.change || `${root}cart/change.js`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:oldKey,quantity,sections:['cart-drawer'],sections_url:location.pathname})});
      await updateCart(data.sections, data.item_count);
      announce(`Sepet güncellendi. ${data.item_count} ürün.`);
      const focusTarget = $$('[data-cart-change]', drawer).find(el => el.dataset.key === oldKey) || $('[data-close-dialog]', drawer);
      focusTarget?.focus();
    } catch (e) {
      const currentError = $('[data-cart-error]', drawer);
      if (currentError) currentError.textContent = e.message;
      announce(e.message);
    } finally { cartBusy = false; drawer?.classList.remove('is-busy'); }
  }
  function activateTab(tab) {
    const parent = tab.closest('[data-tabs]');
    if (!parent) return;
    $$('[role=tab]', parent).forEach(el => {
      const chosen = el === tab;
      el.setAttribute('aria-selected', String(chosen)); el.tabIndex = chosen ? 0 : -1;
      const panel = document.getElementById(el.getAttribute('aria-controls'));
      if (panel) panel.hidden = !chosen;
    });
  }
  function setMedia(gallery, id) {
    if (!gallery || !id || !$(`[data-media="${id}"]`, gallery)) return;
    $$('[data-media]', gallery).forEach(el => {
      el.hidden = el.dataset.media !== String(id);
      if (el.hidden) $$('video', el).forEach(video => video.pause());
    });
    $$('[data-media-target]', gallery).forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mediaTarget === String(id))));
  }
  function updateVariant(section, updateURL = true) {
    const select = $('[data-variant-select]', section);
    const variants = parse($('[data-variants]', section), []);
    const variant = variants.find(v => String(v.id) === select?.value);
    if (!variant) return;
    const planSelect = $('[data-selling-plan]', section);
    if (planSelect) {
      $$('option', planSelect).forEach(option => {
        option.disabled = Boolean(option.value) && !variant.plans.some(p => String(p.id) === option.value);
      });
      if (planSelect.selectedOptions?.[0]?.disabled) planSelect.value = $$('option', planSelect).find(o => !o.disabled)?.value || '';
    }
    const plan = variant.plans.find(p => String(p.id) === planSelect?.value);
    const price = $('[data-variant-price]', section);
    if (price) {
      price.replaceChildren();
      const amount = document.createElement('span'); amount.textContent = cleanText(plan?.priceText || variant.priceText); price.append(amount);
      if (!plan && variant.compareText) { const old = document.createElement('s'); old.textContent = cleanText(variant.compareText); price.append(old); }
    }
    const button = $('[data-add-button]', section);
    const validPlan = planSelect?.value ? Boolean(plan) : section.dataset.requiresPlan !== 'true';
    if (button && !button.closest('form').dataset.busy) {
      button.disabled = !variant.available || !validPlan;
      button.textContent = variant.available && validPlan ? 'Sepete ekle' : 'Tükendi';
    }
    const stock = $('[data-variant-stock]', section); if (stock) stock.textContent = variant.available ? 'Siparişe açık' : 'Tükendi';
    const sku = $('[data-variant-sku]', section); if (sku) sku.textContent = variant.sku || '—';
    const qty = $('input[name=quantity]', section);
    if (qty) {
      qty.min = String(variant.min || 1); qty.step = String(variant.step || 1);
      if (variant.max) qty.max = String(variant.max); else qty.removeAttribute('max');
      if (updateURL) qty.value = String(variant.min || 1);
    }
    const dynamic = $('[data-dynamic-checkout]', section); if (dynamic) dynamic.hidden = !variant.available || !validPlan;
    document.dispatchEvent(new CustomEvent('pata:variant-updated',{detail:{section}}));
    if (updateURL) {
      const next = new URL(location.href); next.searchParams.set('variant', variant.id); history.replaceState({},'',next);
      setMedia($('[data-gallery]', section), variant.mediaId);
    }
  }
  function finderStep(finder, target) {
    finder.dataset.step = String(target);
    $$('[data-finder-step]', finder).forEach(el => { el.hidden = Number(el.dataset.finderStep) !== target; });
    $('[data-finder-back]', finder).hidden = target === 0;
    $('[data-finder-next]', finder).hidden = target === 2;
    $('[data-finder-reset]', finder).hidden = target !== 2;
    $('[data-finder-progress]', finder).textContent = target < 2 ? `0${target + 1} / 02` : 'TAMAMLANDI';
    $('[data-finder-error]', finder).textContent = '';
    if (target === 2) {
      const form = $('form', finder); const values = new FormData(form);
      const links = parse($('[data-finder-links]', finder));
      $('[data-finder-result]', finder).href = links[`${values.get('pet')}-${values.get('category')}`] || `${root}collections/all`;
    }
    const current = $(`[data-finder-step="${target}"]`, finder);
    current.setAttribute('tabindex','-1'); current.focus({preventScroll:true});
  }
  function initHero(element) {
    if (heroes.has(element)) return;
    const slides = $$('[data-hero-slide]', element); const buttons = $$('[data-hero-to]', element);
    if (!slides.length) return;
    const state = {index:0, element, slides, buttons};
    state.show = index => {
      state.index = Math.max(0,Math.min(slides.length - 1,index));
      const count = $('[data-hero-current]',element); if(count) count.textContent=String(state.index+1).padStart(2,'0');
      slides.forEach((slide,i) => {slide.classList.toggle('is-active',i===state.index);slide.setAttribute('aria-hidden',String(i!==state.index));slide.inert=i!==state.index;});
      buttons.forEach((button,i) => button.setAttribute('aria-pressed',String(i===state.index)));
    };
    state.scrolling = () => element.dataset.scroll === 'true' && window.innerWidth >= 750 && !reduced.matches && !window.Shopify?.designMode && slides.length > 1;
    state.update = () => {
      element.classList.toggle('is-scroll',state.scrolling());
      if (!state.scrolling()) return;
      const top = element.getBoundingClientRect().top;
      const sticky = $('.hero-sticky',element);
      const range = element.offsetHeight - sticky.offsetHeight;
      state.show(Math.round(Math.max(0,Math.min(1,(88-top)/Math.max(1,range))) * (slides.length-1)));
    };
    state.to = index => {
      if (state.scrolling()) {
        const range = element.offsetHeight - $('.hero-sticky',element).offsetHeight;
        window.scrollTo({top:window.scrollY+element.getBoundingClientRect().top-88+range*index/Math.max(1,slides.length-1),behavior:'smooth'});
      } else state.show(index);
    };
    element.tabIndex = 0;
    element.setAttribute('aria-label','Ürün hikâyeleri. Ok tuşlarıyla sahne değiştirin.');
    element.addEventListener('keydown', e => {
      if (e.target !== element && !e.target.matches('[data-hero-to]')) return;
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
      e.preventDefault();
      state.to(e.key==='Home'?0:e.key==='End'?slides.length-1:Math.max(0,Math.min(slides.length-1,state.index+(e.key==='ArrowRight'?1:-1))));
    });
    let touch;
    element.addEventListener('touchstart',e=>{touch={x:e.touches[0].clientX,y:e.touches[0].clientY}},{passive:true});
    element.addEventListener('touchend',e=>{if(!touch)return;const dx=e.changedTouches[0].clientX-touch.x,dy=e.changedTouches[0].clientY-touch.y;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5)state.to(Math.max(0,Math.min(slides.length-1,state.index+(dx<0?1:-1))));touch=null},{passive:true});
    heroes.set(element,state); state.show(0); state.update();
  }
  let ticking = false;
  const onScroll = () => {if (ticking) return;ticking=true;requestAnimationFrame(() => {heroes.forEach(state => {if(state.element.isConnected) state.update();else heroes.delete(state.element);});ticking=false;});};
  window.addEventListener('scroll',onScroll,{passive:true}); window.addEventListener('resize',onScroll,{passive:true});
  reduced.addEventListener('change',onScroll);
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target);}}),{threshold:.08}) : null;
  const stepsObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {if(!entry.isIntersecting)return;const parent=entry.target.closest('[data-steps]');$$('.steps-nav a',parent).forEach(a=>a.classList.toggle('is-active',a.hash===`#${entry.target.id}`));}),{rootMargin:'-20% 0px -45% 0px'}) : null;
  async function loadRecommendations(element) {
    if (element.dataset.loaded || !element.dataset.url) return;
    element.dataset.loaded = 'true';
    try {
      const response = await fetch(element.dataset.url); if (!response.ok) return;
      const next = new DOMParser().parseFromString(await response.text(),'text/html');
      const content = $('.recommendation-content', next);
      if (content) { $('.recommendation-content',element)?.replaceWith(content); init(content); }
    } catch { /* Optional recommendations never block purchasing. */ }
  }
  async function predictive(input) {
    const target = $('[data-predictive-results]'); if (!target) return;
    searchAbort?.abort(); const query = input.value.trim();
    if (query.length < 2) {target.replaceChildren();return;}
    searchAbort = new AbortController();
    try {
      const path = new URL(config.search || `${root}search/suggest.json`,location.origin);
      path.searchParams.set('q',query);path.searchParams.set('resources[type]','product');path.searchParams.set('resources[limit]','5');
      const data = await jsonRequest(path,{signal:searchAbort.signal});
      if(input.value.trim()!==query)return;
      target.replaceChildren();
      const products=data.resources?.results?.products || [];
      products.forEach(product => {
        const a=document.createElement('a');a.className='predictive-item';a.href=product.url;
        const source=product.featured_image?.url || product.image;
        if(source){const img=document.createElement('img');img.src=source;img.alt='';img.width=65;img.height=65;a.append(img);}
        const name=document.createElement('span');name.textContent=product.title;a.append(name);target.append(a);
      });
      if (!products.length) {const p=document.createElement('p');p.className='predictive-empty';p.textContent='Ürün bulunamadı. Başka bir kelime deneyin.';target.append(p);}
    } catch(e) {if(e.name!=='AbortError')target.textContent='Tüm sonuçlar için Ara düğmesini kullanın.';}
  }
  document.addEventListener('submit',e => {
    if(e.target.matches('[data-product-form]') && window.fetch && window.FormData) {e.preventDefault();addToCart(e.target);}
    if(e.target.closest('[data-finder]')){e.preventDefault();$('[data-finder-next]',e.target)?.click();}
  });
  document.addEventListener('click',e => {
    const target=e.target.closest('button,a'); if(!target)return;
    if(target.matches('[data-open-cart]') && document.body.dataset.cartDrawer==='true' && $('#CartDrawer')?.showModal){e.preventDefault();openDialog($('#CartDrawer'),target);}
    if(target.matches('[data-open-search]'))openDialog($('#SearchDialog'),target);
    if(target.matches('[data-close-dialog]'))closeDialog(target.closest('dialog'));
    if(target.matches('[data-cart-change]'))changeCart(target);
    if(target.matches('[role=tab]'))activateTab(target);
    if(target.matches('[data-rail-next],[data-rail-prev]')){const parent=target.closest('.tab-panel,section');const rail=$('[data-horizontal]',parent);rail?.scrollBy({left:rail.clientWidth*(target.hasAttribute('data-rail-next')?1:-1),behavior:reduced.matches?'auto':'smooth'});}
    if(target.matches('[data-quantity-step]')){const input=$('input',target.closest('.quantity'));if(Number(target.dataset.quantityStep)>0)input.stepUp();else input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));}
    if(target.matches('[data-media-target]'))setMedia(target.closest('[data-gallery]'),target.dataset.mediaTarget);
    if(target.matches('[data-zoom]')){const image=$('img',target);const dialog=$('[data-zoom-dialog]');if(image&&dialog){$('[data-zoom-content]',dialog).replaceChildren(image.cloneNode(true));openDialog(dialog,target);}}
    if(target.matches('[data-hero-to]'))heroes.get(target.closest('[data-hero]'))?.to(Number(target.dataset.heroTo));
    const finder=target.closest('[data-finder]');
    if(finder){const step=Number(finder.dataset.step||0);if(target.matches('[data-finder-next]')){const current=$(`[data-finder-step="${step}"]`,finder);if(!$('input:checked',current)){$('[data-finder-error]',finder).textContent='Devam etmek için bir seçenek seçin.';return;}finderStep(finder,Math.min(2,step+1));}if(target.matches('[data-finder-back]'))finderStep(finder,Math.max(0,step-1));}
    if(target.closest('.mobile-menu nav'))target.closest('.mobile-menu').open=false;
  });
  document.addEventListener('keydown',e=>{
    if(!e.target.matches('[role=tab]')||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
    e.preventDefault();const tabs=$$('[role=tab]',e.target.closest('[data-tabs]'));let index=tabs.indexOf(e.target);
    if(e.key==='Home')index=0;else if(e.key==='End')index=tabs.length-1;else index=(index+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
    activateTab(tabs[index]);tabs[index].focus();
  });
  document.addEventListener('change',e=>{if(e.target.matches('[data-variant-select],[data-selling-plan]'))updateVariant(e.target.closest('[data-product-section]'));});
  document.addEventListener('input',e=>{if(e.target.matches('[data-predictive-input]')){clearTimeout(searchTimer);searchTimer=setTimeout(()=>predictive(e.target),220);}});
  document.addEventListener('reset',e=>{const finder=e.target.closest('[data-finder]');if(finder)finderStep(finder,0);});
  function init(scope=document){
    bindDialogs(scope);
    $$('[data-hero]',scope).forEach(initHero);
    $$('[data-product-section]',scope).forEach(section=>{updateVariant(section,false);const variants=parse($('[data-variants]',section),[]);const variant=variants.find(v=>String(v.id)===$('[data-variant-select]',section)?.value);setMedia($('[data-gallery]',section),variant?.mediaId);});
    $$('[data-recommendations]',scope).forEach(loadRecommendations);
    if(revealObserver&&!reduced.matches&&document.body.classList.contains('motion-enabled')&&!window.Shopify?.designMode){$$('[data-reveal]',scope).forEach(el=>{el.classList.add('reveal-ready');revealObserver.observe(el);});}
    if(stepsObserver)$$('.story-step',scope).forEach(el=>stepsObserver.observe(el));
  }
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('pata:content-loaded',e=>init(e.detail.scope));
  document.addEventListener('shopify:section:unload',e=>{$$('[data-hero]',e.target).forEach(el=>heroes.delete(el));$$('[data-reveal]',e.target).forEach(el=>revealObserver?.unobserve(el));$$('.story-step',e.target).forEach(el=>stepsObserver?.unobserve(el));});
  document.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-hero-slide]');if(slide){const state=heroes.get(slide.closest('[data-hero]'));state?.show(state.slides.indexOf(slide));}const tab=e.target.closest('[role=tab]');if(tab)activateTab(tab);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();
